import type { IconProps } from '../types/IconProps.ts';
export const CreditCard: IconProps = {
    name: 'CreditCard',
    children: [
        `<path d="M2 10v7c0 1.1.9 2 2 2h16a2 2 0 0 0 2-2v-7M2 10V7c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v3M2 10h20" />`,
    ]
};